import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useStore } from '@/hooks/useStore';
import { CongNoTab } from './components/CongNoTab';
import { TransactionTab } from './components/TransactionTab';
import { MobileTabs } from '@/components/base/MobileUi';

// A separate "Tổng quan" tab used to sit here — removed (Feedback round 3):
// it was mostly empty and duplicated stats/nav shortcuts that already exist
// on the other two tabs. Its one unique, real bit of data (the HTX-wide
// hạn mức allocation block) now lives at the top of the Giao dịch tab, next
// to Tổng thu/Chi — giving a "thống kê tổng quan và lọc xem nhanh" view
// without a third tab.
const TABS = [
  { id: 'debt', label: 'Công nợ', icon: 'ri-money-cny-circle-line' },
  { id: 'transaction', label: 'Giao dịch', icon: 'ri-exchange-line' },
];

export default function HtxFinancePage() {
  useStore();
  const location = useLocation();
  const navState = (location.state as { tab?: string } | null);
  const [activeTab, setActiveTab] = useState(TABS.some((tab) => tab.id === navState?.tab) ? navState!.tab! : 'transaction');

  const handleNavigate = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <div className="mobile-page space-y-4">
      <div>
        <h2 className="text-lg font-bold text-slate-900">Tài chính HTX</h2>
        <p className="metric-caption mt-0.5 text-[11px] text-slate-400">Công nợ và giao dịch của HTX</p>
      </div>
      <MobileTabs tabs={TABS} value={activeTab} onChange={setActiveTab} equal />
      <div className="min-w-0">
          {activeTab === 'debt' && <CongNoTab onNavigate={handleNavigate} />}
          {activeTab === 'transaction' && <TransactionTab />}
      </div>
    </div>
  );
}
